export default __webpack_public_path__ + "static/media/accelerating.b630a500.svg";